import React from 'react';
import { styled } from "../../../stitches.config";
import { ReactComponent as TwoDots } from '../../assets/icons/dots-left.svg?react';
import { h1, h3, h4, p } from '../../commonStyles/Fonts';

interface NumberedListProps {
    children: JSX.Element,
    items: {
        text: string
    }[]
}

const NumberedList = ({ children, items }: NumberedListProps) => {
    return (
        <BenefitsContent>
            {children}
            {
                items.map((item, index) =>
                    <BenefitsContentItem>
                        <BenefitsContentItemNumber>
                            <TwoDots></TwoDots>
                            {index + 1}
                        </BenefitsContentItemNumber>
                        <p className={p()}>{item.text}</p>
                    </BenefitsContentItem>
                )
            }
        </BenefitsContent>
    )
}

export default NumberedList;

const BenefitsContent = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '44px',
    maxWidth: '516px',
    '*': {
        color: '$grayscale100',
    }
})

const BenefitsContentItem = styled('div', {
    display: 'flex',
    height: 'fit-content',
    alignItems: 'flex-start',
    gap: '16px',
    width: '100%',
    p: {
        paddingLeft: '16px',
        borderLeft: '1px solid $grayscale50',
        maxWidth: '436px',
        margin: 0,
        fontSize: '16px',
        lineHeight: '26px',
    },
    '@bp4': {
        gap: '24px',
        p: {
            paddingLeft: '24px',
            borderLeft: '1px solid $grayscale50',
            maxWidth: '436px',
            margin: 0,
            fontSize: '18px',
            lineHeight: '26px',
        },
    }
})

const BenefitsContentItemNumber = styled('div', {
    display: 'flex',
    alignItems: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '30px',
})
